import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromMaterials from '../reducers/materials.reducer';

const getMaterialsState = createSelector(
  fromFeature.getProductsState,
  (state: fromFeature.DashboardState) => state.materials
);

const getMaterialsEntities = createSelector(getMaterialsState, fromMaterials.getMaterialsEntities);

export const getMaterials = createSelector(getMaterialsEntities, (entities) => {
  return entities;
});
